var namespace = require('./namespace');

    /**
     * set "nested" object property
     */
    function set(obj, prop, val){
        var parts = (/^(.+)\.(.+)$/).exec(prop);
        if (parts){
            namespace(obj, parts[1])[parts[2]] = val;
        } else {
            obj[prop] = val;
        }
    }

    module.exports = set;





/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/object/set.js
 ** module id = 27
 ** module chunks = 0
 **/